<!-- ── Toolbar: review counters + search + filter + bulk-delete + import ────
     The counters sit ON the filter row, because that is what they are: one
     click each, and what they open is what the row beside them searches and
     filters. -->
<div class="list-price-observations__toolbar">
  <div class="list-price-observations__counters">
    <button
      type="button"
      class="list-price-observations__counter list-price-observations__counter--unresolved"
      [class.is-active]="filters.status === 'unknown_customer'"
      *ngIf="(unresolvedCount$ | async) as unresolved"
      (click)="filterByStatus('unknown_customer')"
    >
      <span class="list-price-observations__counter-value">{{ unresolved }}</span>
      <span class="list-price-observations__counter-label">
        {{ "knowledge_base.price_observations.counter.unresolved" | translate }}
      </span>
    </button>
    <button
      type="button"
      class="list-price-observations__counter list-price-observations__counter--to-verify"
      [class.is-active]="filters.status === 'to_verify' && !filters.state"
      *ngIf="(toVerifyCount$ | async) as toVerify"
      (click)="filterByStatus('to_verify')"
    >
      <span class="list-price-observations__counter-value">{{ toVerify }}</span>
      <span class="list-price-observations__counter-label">
        {{ "knowledge_base.price_observations.counter.to_verify" | translate }}
      </span>
    </button>
    <button
      type="button"
      class="list-price-observations__counter list-price-observations__counter--conflict"
      [class.is-active]="filters.state === 'conflict'"
      *ngIf="(conflictCount$ | async) as conflict"
      (click)="filterByConflict()"
    >
      <span class="list-price-observations__counter-value">{{ conflict }}</span>
      <span class="list-price-observations__counter-label">
        {{ "knowledge_base.price_observations.counter.conflict" | translate }}
      </span>
    </button>
  </div>
  <ui-form-field
    [formControl]="searchControl"
    [prefixIcon]="'search'"
    [placeholder]="'knowledge_base.price_observations.search_placeholder' | translate"
    class="list-price-observations__search"
  >
  </ui-form-field>
  <div class="filter-button-group">
    <button class="action-button" (click)="setFilter()" [ngClass]="{ activeFilter: hasActiveFilters }">
      <div class="action-button-icon">
        <img src="assets/icones/filter_icon.svg" alt="" />
      </div>
      <span class="action-button-text">{{ "knowledge_base.filter" | translate }}</span>
      <div class="clear-icon-container">
        <img
          class="clear-icon"
          *ngIf="hasActiveFilters"
          (click)="clearFilter(); $event.stopPropagation()"
          src="assets/icones/clear-icon.svg"
          alt=""
        />
        <div class="clear-tooltip" *ngIf="hasActiveFilters">
          {{ "common.clear_filters" | translate }}
        </div>
      </div>
    </button>
  </div>
  <div class="list-price-observations__toolbar-actions">
    <ng-container *appHasPermission="{ module: 'knowledge_base', action: 'delete' }">
      <ui-button
        *ngIf="selected.size > 0"
        type="danger"
        icon="trash-cc"
        iconSize="large"
        [label]="('common.delete' | translate) + ' (' + selected.size + ')'"
        (click)="bulkDelete()"
      >
      </ui-button>
    </ng-container>
    <!-- Exports the CURRENT selection: the same filters the list is showing
         are sent, and the backend reuses the very function the list filters
         with. -->
    <ui-button
      type="secondary"
      icon="download"
      [disabled]="isExporting"
      [label]="'common.export' | translate"
      (click)="exportObservations()"
    >
    </ui-button>
    <ui-button
      *appHasPermission="{ module: 'knowledge_base', action: 'create' }"
      type="primary"
      icon="upload"
      [label]="'knowledge_base.price_observations.import_prices' | translate"
      (click)="openImportDialog()"
    >
    </ui-button>
  </div>
</div>

<!-- ── Table ─────────────────────────────────────────────────────────────── -->
<div class="list-price-observations__table">
  <!-- Header -->
  <div class="list-price-observations__table-header">
    <div class="list-price-observations__table-cell list-price-observations__table-cell--checkbox">
      <mat-checkbox [checked]="isAllSelected" [indeterminate]="isPartialSelected" (change)="toggleAll($event.checked)"> </mat-checkbox>
    </div>
    <div class="list-price-observations__table-cell">
      {{ "knowledge_base.price_observations.col.customer" | translate }}
    </div>
    <div class="list-price-observations__table-cell">
      {{ "knowledge_base.price_observations.col.product" | translate }}
    </div>
    <div class="list-price-observations__table-cell list-price-observations__table-cell--sortable" (click)="onSort('price')">
      {{ "knowledge_base.price_observations.col.price" | translate }}
      <div class="list-price-observations__table-cell-sort-actions">
        <span class="arrow-up" [class.active]="sortField === 'price' && sortMode === 'asc'"></span>
        <span class="arrow-down" [class.active]="sortField === 'price' && sortMode === 'desc'"></span>
      </div>
    </div>
    <div class="list-price-observations__table-cell">
      {{ "knowledge_base.price_observations.col.unit" | translate }}
    </div>
    <div class="list-price-observations__table-cell list-price-observations__table-cell--sortable" (click)="onSort('observed_at')">
      {{ "knowledge_base.price_observations.col.observed_at" | translate }}
      <div class="list-price-observations__table-cell-sort-actions">
        <span class="arrow-up" [class.active]="sortField === 'observed_at' && sortMode === 'asc'"></span>
        <span class="arrow-down" [class.active]="sortField === 'observed_at' && sortMode === 'desc'"></span>
      </div>
    </div>
    <div class="list-price-observations__table-cell">
      {{ "knowledge_base.price_observations.col.valid_until" | translate }}
    </div>
    <div class="list-price-observations__table-cell">
      {{ "knowledge_base.price_observations.col.status" | translate }}
    </div>
    <div class="list-price-observations__table-cell">
      {{ "knowledge_base.price_observations.col.source" | translate }}
    </div>
    <div class="list-price-observations__table-cell list-price-observations__table-cell--actions">
      {{ "knowledge_base.price_observations.col.actions" | translate }}
    </div>
  </div>

  <!-- Scrollable body -->
  <div class="list-price-observations__table-body">
    <!-- Loading state -->
    <div class="list-price-observations__loading" *ngIf="loading$ | async">
      <div class="list-price-observations__loading-spinner"></div>
    </div>

    <!-- Rows -->
    <ng-container *ngIf="!(loading$ | async) && rows.length > 0">
      <div
        *ngFor="let item of rows; trackBy: trackById"
        class="list-price-observations__table-row"
        [class.is-unresolved]="needsCustomer(item)"
        [class.is-to-verify]="needsProduct(item)"
        [class.is-conflict]="isConflict(item)"
      >
        <div class="list-price-observations__table-cell list-price-observations__table-cell--checkbox" (click)="$event.stopPropagation()">
          <mat-checkbox [checked]="isSelected(item.id)" (change)="toggleOne(item.id, $event.checked)"> </mat-checkbox>
        </div>

        <!-- Customer. The raw address is shown when nothing resolved: it is
             what the operator recognises, and what resolving it will teach the
             registry. -->
        <div class="list-price-observations__table-cell">
          <!-- A global tariff is FOR everyone; a dash would read as "no data". -->
          <span
            *ngIf="isGlobalAudience(item)"
            class="list-price-observations__badge list-price-observations__badge--audience"
          >
            {{ "knowledge_base.price_observations.audience.all_customers" | translate }}
          </span>
          <span
            *ngIf="isGroupAudience(item)"
            class="list-price-observations__badge list-price-observations__badge--audience"
            [matTooltip]="groupNames(item)"
            matTooltipPosition="above"
          >
            {{ groupNames(item) || ("knowledge_base.price_observations.audience.group" | translate) }}
          </span>
          <span *ngIf="!isGlobalAudience(item) && !isGroupAudience(item)">{{ displayCustomer(item) }}</span>
          <!-- The weak channel stays visible: a price attributed by domain
               alone must be recognisable, because 17 % of domains map more
               than one customer on the largest tenant measured. -->
          <span
            *ngIf="isWeakAttribution(item)"
            class="list-price-observations__badge list-price-observations__badge--weak"
            [matTooltip]="'knowledge_base.price_observations.resolved_by.domain_tooltip' | translate"
            matTooltipPosition="above"
          >
            {{ resolvedByLabel(item) }}
          </span>
        </div>

        <!-- STACKED, not side by side: what the file wrote and what the
             matcher proposes are two different statements about one product,
             and on one line the proposal was cut in half by the badge that
             counted it. -->
        <div class="list-price-observations__table-cell list-price-observations__table-cell--product">
          <span class="list-price-observations__product-raw">{{ displayProduct(item) }}</span>
          <!-- What the matcher thinks it is, in grey: a proposal, not a fact.
               It stands where the "Not recognised" tag did -- the raw code and
               the status pill already said the row is unrecognised; only this
               says which product would answer it. The count of the OTHERS
               rides on it as "+2" instead of a badge of its own: the number
               was never the point, the name is. -->
          <button
            *ngIf="topSuggestionLabel(item) as suggested"
            type="button"
            class="list-price-observations__suggested"
            [matTooltip]="'knowledge_base.price_observations.suggestions_tooltip' | translate"
            matTooltipPosition="above"
            (click)="onEditClick(item); $event.stopPropagation()"
          >
            <span class="list-price-observations__suggested-arrow" aria-hidden="true">↳</span>
            <span class="list-price-observations__suggested-label">{{ suggested }}</span>
            <span *ngIf="otherSuggestionCount(item) as others" class="list-price-observations__suggested-more">
              +{{ others }}
            </span>
          </button>
        </div>
        <div class="list-price-observations__table-cell">{{ displayPrice(item) }}</div>
        <!-- The unit as the file wrote it. The basis rides on the TOOLTIP --
             spelled out in the cell it read "Unit (base unit)" and wrapped the
             narrowest column over two lines to say nothing. -->
        <div
          class="list-price-observations__table-cell"
          [matTooltip]="unitBasisLabel(item)"
          matTooltipPosition="above"
        >
          {{ displayUnit(item) }}
        </div>
        <div class="list-price-observations__table-cell">
          {{ item.observed_at ? (item.observed_at | adaptToUserUtcOffset | date: DATE_FORMAT) : "--" }}
        </div>
        <div class="list-price-observations__table-cell">
          {{ item.valid_until ? (item.valid_until | adaptToUserUtcOffset | date: DATE_FORMAT) : "--" }}
        </div>

        <!-- State. A conflict publishes NOTHING, so the tooltip says it -- the
             operator has to pick which of the two quotes survives. -->
        <div class="list-price-observations__table-cell">
          <!-- The badge shows the DERIVED status, computed once by the
               backend from (state, is_current, scope, freshness) -- and it is
               the ONLY status this cell paints. `scope='unresolved'` already
               resolves to `status='unknown_customer'` (price_contract I7), so
               the scope badge beside it repeated the pill word for word and
               squeezed it to "Unk...". The explanation the scope badge carried
               moved onto the pill's own tooltip. -->
          <ui-status-badge
            [label]="statusLabel(item)"
            [tone]="statusTone(item)"
            [tooltip]="statusTooltip(item)"
          ></ui-status-badge>
        </div>

        <!-- Provenance, per line: the file and the row. Read-only — and
             openable, because naming a source is not showing it.

             The NAME is text and the eye opens it, which is how the whole app
             already offers a preview (smart inbox attachments). A file name
             styled as a link was the pricing screens' own invention, and it
             read as navigation on a screen where nothing navigates. -->
        <div class="list-price-observations__table-cell">
          <ng-container *ngIf="displaySource(item) as sourceName">
            <span
              class="list-price-observations__source-name"
              [matTooltip]="item.source_quote || sourceName"
              matTooltipPosition="above"
              >{{ sourceName }}</span
            >
          </ng-container>
          <button
            *ngIf="item.document_id"
            type="button"
            class="preview-icon"
            [matTooltip]="'common.preview' | translate"
            matTooltipPosition="above"
            [attr.aria-label]="'common.preview' | translate"
            (click)="openSource(item, $event)"
          >
            <ui-svg-icon svgIcon="eye" size="small"></ui-svg-icon>
          </button>
          <!-- A human overrode what the file said. That is PROVENANCE, and it
               belongs beside the file it contradicts -- in the status column it
               was a second vocabulary on a cell that answers one question, and
               it squeezed the status pill it sat next to. Same badge as the
               `domain` attribution, for the same reason: a weaker source. -->
          <span
            *ngIf="item.corrected_manually"
            class="list-price-observations__badge list-price-observations__badge--weak"
            [matTooltip]="('knowledge_base.price_observations.corrected_tooltip' | translate) + ' ' + (item.corrected_at | date: DATE_FORMAT) + (item.corrected_by ? ' — ' + item.corrected_by : '')"
            matTooltipPosition="above"
          >
            {{ "knowledge_base.price_observations.corrected" | translate }}
          </span>
        </div>

        <div class="list-price-observations__table-cell list-price-observations__table-cell--actions" (click)="$event.stopPropagation()">
          <!-- ONE pencil, ONE bin. The dialog carries client, product, price,
               dates, scope — and the conflict banner. A Remplacé/Doublon row
               is read-only, the server refuses anyway. -->
          <ng-container *appHasPermission="{ module: 'knowledge_base', action: 'edit' }">
            <button
              *ngIf="!isLocked(item)"
              type="button"
              class="list-price-observations__action"
              [matTooltip]="'knowledge_base.price_observations.actions.edit_tooltip' | translate"
              matTooltipPosition="above"
              (click)="onEditClick(item)"
            >
              <mat-icon>edit_outlined</mat-icon>
            </button>
          </ng-container>
          <button
            *appHasPermission="{ module: 'knowledge_base', action: 'delete' }"
            type="button"
            class="list-price-observations__action list-price-observations__action--danger"
            [matTooltip]="'common.delete' | translate"
            matTooltipPosition="above"
            (click)="deleteRow(item)"
          >
            <mat-icon>delete_outline</mat-icon>
          </button>
        </div>
      </div>
    </ng-container>

    <!-- Empty state -->
    <div *ngIf="rows.length === 0 && !(loading$ | async)" class="list-price-observations__empty">
      <img class="list-price-observations__empty-illustration" src="assets/icones/no-result-search.svg" alt="" />
      <h3 *ngIf="!keyword && !hasActiveFilters">
        {{ "knowledge_base.price_observations.empty_state" | translate }}
      </h3>
      <h3 *ngIf="keyword || hasActiveFilters">
        {{ "knowledge_base.price_observations.empty_state_search" | translate }}
      </h3>
    </div>
  </div>
</div>

<!-- ── Pagination ────────────────────────────────────────────────────────── -->
<app-pagination *ngIf="rows.length > 0" [pagination]="metadata$ | async" (toPageEvent)="toPage($event)"> </app-pagination>
